import { render, staticRenderFns } from "./BundleSmallToModalButton.vue?vue&type=template&id=6747ed00&scoped=true&"
import script from "./BundleSmallToModalButton.vue?vue&type=script&lang=js&"
export * from "./BundleSmallToModalButton.vue?vue&type=script&lang=js&"
import style0 from "./BundleSmallToModalButton.vue?vue&type=style&index=0&id=6747ed00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747ed00",
  null
  
)

export default component.exports